/**
 * Japanese translations for Report Issue feature
 * Used as fallback when i18n fails or application crashes
 */
export const japaneseTranslations = {
    reportIssue: {
        description: '問題の詳細をご記入のうえ、「送信」ボタンをクリックしてMyCASEサポートチームに報告してください。詳細を補足する画像を添付することもできます。',
        placeholder: '詳細を入力',
        attachImage: 'ファイルを添付',
        emailMeACopy: 'コピーを自分に送る',
        reportSuccessTitle: '送信完了',
        charactersRemainingLabel: '残りの文字数',
        reportSuccessMessage: 'MyCASEサポートチームが内容を確認し、対応いたします。ありがとうございます！',
        pleaseselectextension: '拡張子が「jpg/jpeg/gif/png/tif/tiff/pdf/bmp/msg/doc/docx/xls/txt/heic/html」の画像のみを選択してください',
        close: '閉じる',
        submit: '送信',
        cancel: 'キャンセル'
    }
};
